"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgoliaSearchReducer = void 0;
const types_1 = require("../types");
const AlgoliaSearchReducer = (state, action) => {
    switch (action.type) {
        case types_1.AlgoliaActionType.UPDATE_QUERY: {
            const { value } = action;
            return {
                ...state,
                queries: {
                    ...state.queries,
                    [value.queryId]: value.query,
                },
            };
        }
        case types_1.AlgoliaActionType.SET_RESULT: {
            const { value } = action;
            return {
                ...state,
                results: {
                    ...state.results,
                    [value.key]: value.result,
                },
            };
        }
        case types_1.AlgoliaActionType.SET_STATUS: {
            return {
                ...state,
                status: action.value,
            };
        }
        default:
            return state;
    }
};
exports.AlgoliaSearchReducer = AlgoliaSearchReducer;
//# sourceMappingURL=algoliaSearchReducer.js.map